import { render, staticRenderFns } from "./crossfilter.vue?vue&type=template&id=16097da3&"
import script from "./crossfilter.vue?vue&type=script&lang=js&"
export * from "./crossfilter.vue?vue&type=script&lang=js&"
import style0 from "./crossfilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports